import React from 'react'

function Footer() {
    return (
        <footer className='footer mt-5 p-3'>
        2021 &copy; SalesData
         </footer>
    )
}

export default Footer
